'use strict';

module.exports = function (string) {
  if (typeof string !== 'string') {
    return '';
  }

  return string
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web-drop-in/lib/sanitize-html.js
// module id = 372
// module chunks = 0